import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import "./i18n";
import "./styles.css";
import { applyAppTitle } from "./lib/app-title";
import { identityService } from "./features/identity/identity-service";
import { shellNotificationsClient } from "./infrastructure/notifications";
import { resolveShellRemoteRuntimeConfigs } from "./infrastructure/shell-runtime/remote-configs";
import {
  configureShellRuntime,
  createShellSessionService,
  getShellRuntime,
} from "./infrastructure/shell-runtime/runtime";
import { createShellUiClient } from "./infrastructure/shell-runtime/ui-client";
import { initializeShellThemeStore } from "./state/shell-theme-store";

configureShellRuntime({
  capabilities: {
    identity: identityService,
    notifications: shellNotificationsClient,
    session: createShellSessionService(),
    ui: createShellUiClient(),
  },
  remoteConfigs: resolveShellRemoteRuntimeConfigs(),
});
getShellRuntime();
initializeShellThemeStore();

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element #root not found");
}

const root = ReactDOM.createRoot(rootElement);

applyAppTitle();

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
